module.exports = __webpack_public_path__ + "static/media/nv-noire.5dc03c3b.jpg";